import { LinearGradient } from 'expo-linear-gradient';

import { useColors } from '@/hooks/useColors';

/**
 * The fade behind a floating header or footer, so the draft scrolls out under
 * the controls instead of stopping at a solid bar. It holds the sheet's fill
 * across `holdHeight`, where the controls sit, and clears over the rest of
 * `height`, so text is gone before it reaches them rather than ghosting
 * through beside them. The sheet is opaque, so the fill is the sheet's own
 * and the fade has no visible edge. It takes no touches.
 */
export function EdgeFade({
  edge,
  height,
  holdHeight,
}: {
  edge: 'top' | 'bottom';
  height: number;
  holdHeight: number;
}) {
  const { colors } = useColors();

  if (height <= 0) {
    return null;
  }

  const sheetFill = colors.background[0];

  const clear = `${sheetFill}00`;

  const hold = Math.min(1, Math.max(0, holdHeight / height));

  return (
    <LinearGradient
      colors={edge === 'top' ? [sheetFill, sheetFill, clear] : [clear, sheetFill, sheetFill]}
      locations={edge === 'top' ? [0, hold, 1] : [0, 1 - hold, 1]}
      pointerEvents="none"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        height,
        ...(edge === 'top' ? { top: 0 } : { bottom: 0 }),
      }}
    />
  );
}
